import { MessageDialog } from './dialogs/message/message.dialog';
import { ImageGalleryDialog } from './dialogs/image.gallery/image.gallery.component';
import { LiveHubManagerComponent } from './dialogs/license.details/components/livehub/livehub.component';
import { WMIDataComponent } from './dialogs/license.details/components/wmi.data/wmi.data.component';
import { AddRegistryValueDialog } from './dialogs/add.registry.value/add.registry.value.dialog';
import { UpdateCPUBenchmarkDialog } from './dialogs/update.cpubenchmark/update.cpubenchmark.dialog';
import { PoolStudioBubbleDialog } from './dialogs/poolstudio.bubble/poolstudio.bubble.dialog';
import { UpdateCPUBenchmarksComponent } from './_updater/update.cpubenchmarks/update.cpubenchmarks.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { BrowserModule } from '@angular/platform-browser';
import { PaginatorModule } from './shared/components/paginator/paginator.component';

// DIALOG COMPONENTS
import { AddAttendeeDialog } from './dialogs/add.attendee/add.attendee.dialog';
import { AddClassDialog } from './dialogs/add.class/add.class.dialog';
import { AddCreditCardDialog } from './dialogs/add.credit.card/add.credit.card.dialog';
import { AddCreditDialog } from './dialogs/add.credit/add.credit.dialog';
import { AddDiscountDialog } from './dialogs/add.discount/add.discount.dialog';
import { AddEmailTemplateDialog } from './dialogs/add.email.template/add.email.template.dialog';
import { AddEventDialog } from './dialogs/add.event/add.event.dialog';
import { AddGISDialog } from './dialogs/add.gis/add.gis.dialog';
import { AddInvoiceDialog } from './dialogs/add.invoice/add.invoice.dialog';
import { AddLicenseDialog } from './dialogs/add.license/add.license.dialog';
import { AddMemberDialog } from './dialogs/add.member/add.member.dialog';
import { AddNotePromptDialog } from './dialogs/add.note.prompt/add.note.prompt.dialog';
import { ConfirmDialog } from './dialogs/confirm/confirm.dialog';
import { CreditCardDetailsDialog } from './dialogs/credit.card.details/credit.card.details.dialog';
import { CreditCardDetailsComponent } from './dialogs/credit.card.details/components/credit.card.details/credit.card.details.component';
import { EditDiscountDialog } from './dialogs/edit.discount/edit.discount.dialog';
import { EditCreditCardDialog } from './dialogs/edit.credit.card/edit.credit.card.dialog';
import { EditClassDialog } from './dialogs/edit.class/edit.class.dialog';
import { EditEmailTemplateDialog } from './dialogs/edit.email.template/edit.email.template.dialog';
import { EditEventDialog } from './dialogs/edit.event/edit.event.dialog';
import { EditEventEmails } from './dialogs/edit.event/components/edit.event.emails/edit.event.emails';
import { EmailDialog } from './dialogs/email/email.dialog';
import { EmailPreviewDialog } from './dialogs/email.preview/email.preview.dialog';
import { GISRefundDialog } from './dialogs/gis.refund/gis.refund.dialog';
import { GISOrderHistoryDialog } from './dialogs/gis.order.history/gis.order.history.dialog';
import { InvoiceDetailsDialog } from './dialogs/invoice.details/invoice.details.dialog';
import { KeyReactivateDialog } from './dialogs/key.reactivate/key.reactivate.dialog';
import { KeyReactivateDevDialog } from './dialogs/key.reactivate.dev/key.reactivate.dev.dialog';
import { KeyReassignDialog } from './dialogs/key.reassign/key.reassign.dialog';
import { KeyTransferDialog } from './dialogs/key.transfer/key.transfer.dialog';

import { MakePaymentDialog } from './dialogs/make.payment/make.payment.dialog';
import { MemberDetailsDialog } from './dialogs/member.details/member.details.dialog'
import { MemberDetailsComponent } from './dialogs/member.details/components/member.details/member.details.component';
import { MergeProfilesDialog } from './dialogs/merge.profiles/merge.profiles.dialog';
import { NoteDetailsDialog } from './dialogs/note.details/note.details.dialog';
import { NoteDetailsFullComponent } from './dialogs/note.details/components/note.details.full/note.details.full.component';
import { NoteDetailsBasicComponent } from './dialogs/note.details/components/note.details.basic/note.details.basic.component';
import { RescheduleAttendeeDialog } from './dialogs/reschedule.attendee/reschedule.attendee.dialog';
import { SalesReportDetailsDialog } from './dialogs/sales.report.details/sales.report.details.dialog';
import { SalesReportDetailsComponent } from './dialogs/sales.report.details/components/sales.report.details/sales.report.details.component';
import { StatsTop200Dialog } from './dialogs/stats.top200/stats.top200.dialog';
import { StatsUsageHistoryChartDialog } from './dialogs/stats.usage.history.chart/stats.usage.history.chart.dialog';
import { StatsVendorEditDialog } from './dialogs/stats.vendor.edit/stats.vendor.edit.dialog';
import { StatsVendorEmailDialog } from './dialogs/stats.vendor.email/stats.vendor.email.dialog';
import { StatsVendorItemsDialog } from './dialogs/stats.vendor.items/stats.vendor.items.dialog';
import { TicketAddDialog } from './dialogs/ticket.add/ticket.add.dialog';
import { TicketDetailsDialog } from './dialogs/ticket.details/ticket.details.dialog';
import { TemplateSelectionComponent } from './shared/components/template.selection/template.selection.component';
import { TOSSettingItemDialog } from './dialogs/tos.setting.item/tos.setting.item.dialog';
import { TransferMemberDialog } from './dialogs/transfer.member/transfer.member.dialog';
import { UpdateUpdaterDialog } from './dialogs/update.updater/update.updater.dialog';

// LICENSE DETAILS DIALOG COMPONENTS
import { LicenseDetailsDialog } from './dialogs/license.details/license.details.dialog';
import { LicenseDetailsComponent } from './dialogs/license.details/components/license.details.compnent';
import { LicenseTransferDetailsComponent } from './dialogs/license.details/components/transfer.details/transfer.detials.component'
import { PCLimiterComponent } from './dialogs/license.details/components/pc.limiter/pc.limiter.component';

// DIALOG WINDOWS
import { LicenseDetailsWindow } from './dialog-windows/license.details/license.details.window';
import { MemberDetailsWindow } from './dialog-windows/member.details/member.details.window';
import { EmailWindow } from './dialog-windows/email/email.window';
import { NoteWindow } from './dialog-windows/note/note.window';
import { TicketWindow } from './dialog-windows/ticket/ticket.window';
import { TicketAddWindow } from './dialog-windows/ticket.add/ticket.add.window';

import { ConversationHistoryDialog } from './dialogs/conversation.history/conversation.history.dialog';

import {
    TabViewModule,
    DropdownModule,
    OverlayPanelModule,
    CalendarModule,
    ScheduleModule,
    InputSwitchModule,
    CheckboxModule,
    DragDropModule,
    ChartModule,
    MenuModule,
    MenuItem,
    MultiSelectModule,
    ToggleButtonModule,
    SplitButtonModule,
    TooltipModule,
    SplitButton,
    SelectButtonModule
} from 'primeng/primeng';

// CKEditor IMPORT
import { CKEditorModule } from 'ng2-ckeditor';
import { PipesModule } from './pipes/_pipes.module';

// PERFECT-SCROLL IMPORTS & CONFIG
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { clientFilesFilter, registryFilter } from './pipes/filter.pipe';
import { RegistryEditorComponent } from './dialogs/license.details/components/registry.editor/registry.editor.component';
import { LicenseUpdateManagerComponent } from './dialogs/license.details/components/update.manager/update.manager.component';
import { UpdateGroupDialog } from './dialogs/update.group/update.group.dialog';
import { IFrameDialog } from './dialogs/iframe/iframe.dialog.component';
import { LicenseCloudManagerComponent } from './dialogs/license.details/components/license.cloud.manager/license.cloud.manager.component';
import { UpdateGPUBenchmarkDialog } from './dialogs/update.gpubenchmark/update.gpubenchmark.dialog';
import { AddGlobalMACWhitelist } from './dialogs/add.global.mac.whitelist.dialog/add.global.mac.whitelist.dialog';
import { AddGlobalPhoneWhitelist } from './dialogs/add.global.phone.whitelist.dialog/add.global.phone.whitelist.dialog';
import { AddGlobalAddressWhitelist } from './dialogs/add.global.address.whitelist.dialog/add.global.address.whitelist.dialog';
const PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = { suppressScrollX: true };

@NgModule({
    declarations: [
        // DIALOG WINDOW COMPONENTS
        AddAttendeeDialog,
        AddClassDialog,
        AddCreditCardDialog,
        AddCreditDialog,
        AddDiscountDialog,
        AddEmailTemplateDialog,
        AddEventDialog,
        AddGISDialog,
        AddInvoiceDialog,
        AddLicenseDialog,
        AddMemberDialog,
        AddNotePromptDialog,
        ConfirmDialog,
        CreditCardDetailsDialog,
        CreditCardDetailsComponent,
        EditClassDialog,
        EditCreditCardDialog,
        EditDiscountDialog,
        EditEmailTemplateDialog,
        EditEventDialog,
        EditEventEmails,
        EmailDialog,
        EmailPreviewDialog,
        GISRefundDialog,
        GISOrderHistoryDialog,

        InvoiceDetailsDialog,
        KeyReactivateDialog,
        KeyReactivateDevDialog,
        KeyReassignDialog,
        KeyTransferDialog,
        LicenseCloudManagerComponent,
        WMIDataComponent,
        LiveHubManagerComponent,
        RegistryEditorComponent,
        LicenseUpdateManagerComponent,
        MakePaymentDialog,
        MemberDetailsDialog,
        MemberDetailsComponent,
        MergeProfilesDialog,
        NoteDetailsDialog,
        NoteDetailsFullComponent,
        NoteDetailsBasicComponent,
        RescheduleAttendeeDialog,
        SalesReportDetailsDialog,
        SalesReportDetailsComponent,
        StatsTop200Dialog,
        StatsUsageHistoryChartDialog,
        StatsVendorEditDialog,
        StatsVendorEmailDialog,
        StatsVendorItemsDialog,
        TicketAddDialog,
        TicketDetailsDialog,
        TemplateSelectionComponent,
        TOSSettingItemDialog,
        TransferMemberDialog,
        UpdateUpdaterDialog,
        UpdateCPUBenchmarkDialog,
        UpdateGPUBenchmarkDialog,
        AddRegistryValueDialog,
        ImageGalleryDialog,
        UpdateGroupDialog,
        MessageDialog,
        PoolStudioBubbleDialog,

		// LICENSE DETAILS DIALOG
		LicenseDetailsDialog,
        LicenseDetailsComponent,
		LicenseTransferDetailsComponent,
		PCLimiterComponent,

        // WINDOW
        LicenseDetailsWindow,
        MemberDetailsWindow,
        EmailWindow,
        NoteWindow,
        TicketWindow,
        TicketAddWindow,
        IFrameDialog,
        AddGlobalMACWhitelist,
        AddGlobalPhoneWhitelist,
        AddGlobalAddressWhitelist,

        //
        ConversationHistoryDialog
    ],
    imports: [
        CommonModule,
        BrowserModule,
        RouterModule,
        FormsModule,
        ReactiveFormsModule,

        // PRIMENG
        TabViewModule,
        DropdownModule,
        PaginatorModule,
        OverlayPanelModule,
        CalendarModule,
        ScheduleModule,
        InputSwitchModule,
        CheckboxModule,
        DragDropModule,
        ChartModule,
        MenuModule,
        MultiSelectModule,
        ToggleButtonModule,
        SplitButtonModule,
        TooltipModule,
        SelectButtonModule,
        PipesModule,

        CKEditorModule,
        PerfectScrollbarModule
    ],
    entryComponents: [
        AddAttendeeDialog,
        AddClassDialog,
        AddCreditCardDialog,
        AddCreditDialog,
        AddDiscountDialog,
        AddEmailTemplateDialog,
        AddEventDialog,
        AddGISDialog,
        AddInvoiceDialog,
        AddLicenseDialog,
        AddMemberDialog,
        AddNotePromptDialog,
        ConfirmDialog,
        CreditCardDetailsDialog,
        EditClassDialog,
        EditCreditCardDialog,
        EditDiscountDialog,
        EditEmailTemplateDialog,
        EditEventDialog,
        EditEventEmails,
        EmailDialog,
        EmailPreviewDialog,
        GISRefundDialog,
        GISOrderHistoryDialog,

        InvoiceDetailsDialog,
        KeyReactivateDialog,
        KeyReactivateDevDialog,
        KeyReassignDialog,
        KeyTransferDialog,
        LicenseCloudManagerComponent,
        WMIDataComponent,
        LiveHubManagerComponent,
        RegistryEditorComponent,
        LicenseUpdateManagerComponent,
        MakePaymentDialog,
        MemberDetailsDialog,
        MergeProfilesDialog,
        NoteDetailsDialog,
        RescheduleAttendeeDialog,
        SalesReportDetailsDialog,
        StatsTop200Dialog,
        StatsUsageHistoryChartDialog,
        StatsVendorEditDialog,
        StatsVendorEmailDialog,
        StatsVendorItemsDialog,
        TicketDetailsDialog,
        TransferMemberDialog,
        UpdateUpdaterDialog,
        UpdateCPUBenchmarkDialog,
        UpdateGPUBenchmarkDialog,
        AddRegistryValueDialog,
        ImageGalleryDialog,
        UpdateGroupDialog,
        MessageDialog,
        PoolStudioBubbleDialog,
        
		// LICENSE DETAILS DIALOG
		LicenseDetailsDialog,

        TicketAddDialog,
        TOSSettingItemDialog,
        IFrameDialog,

        AddGlobalMACWhitelist,
        AddGlobalPhoneWhitelist,
        AddGlobalAddressWhitelist,

        ConversationHistoryDialog
    ],
    exports: [
        // PRIMENG
        TabViewModule,
        DropdownModule,
        PaginatorModule,
        OverlayPanelModule,
        CalendarModule,
        ScheduleModule,
        InputSwitchModule,
        CheckboxModule,
        DragDropModule,
        ChartModule,
        MenuModule,
        MultiSelectModule,
        ToggleButtonModule,
        SplitButtonModule,
        TooltipModule,
        SelectButtonModule,

        PaginatorModule,

        // DIALOG WINDOW COMPONENTS
        AddCreditCardDialog,
        AddCreditDialog,
        AddDiscountDialog,
        AddEmailTemplateDialog,
        AddEventDialog,
        AddGISDialog,
        AddInvoiceDialog,
        AddLicenseDialog,
        AddMemberDialog,
        AddNotePromptDialog,
        ConfirmDialog,
        CreditCardDetailsDialog,
        CreditCardDetailsComponent,
        EditCreditCardDialog,
        EditDiscountDialog,
        EditEmailTemplateDialog,
        EditEventDialog,
        EmailDialog,
        EmailPreviewDialog,
        GISRefundDialog,
        GISOrderHistoryDialog,

        InvoiceDetailsDialog,
        KeyReactivateDialog,
        KeyReactivateDevDialog,
        KeyReassignDialog,
        KeyTransferDialog,
        LicenseCloudManagerComponent,
        WMIDataComponent,
        LiveHubManagerComponent,
        RegistryEditorComponent,
        LicenseUpdateManagerComponent,
        MakePaymentDialog,
        MemberDetailsDialog,
        MemberDetailsComponent,
        MergeProfilesDialog,
        NoteDetailsDialog,
        NoteDetailsFullComponent,
        NoteDetailsBasicComponent,
        RescheduleAttendeeDialog,
        SalesReportDetailsDialog,
        SalesReportDetailsComponent,
        StatsTop200Dialog,
        StatsUsageHistoryChartDialog,
        StatsVendorEditDialog,
        StatsVendorEmailDialog,
        StatsVendorItemsDialog,
        TicketAddDialog,
        TicketDetailsDialog,
        TemplateSelectionComponent,
        TOSSettingItemDialog,
        TransferMemberDialog,
        UpdateUpdaterDialog,
        AddRegistryValueDialog,
        ImageGalleryDialog,
        UpdateGroupDialog,
        MessageDialog,

        AddGlobalMACWhitelist,
        AddGlobalPhoneWhitelist,
        AddGlobalAddressWhitelist,

		// LICENSE DETAILS DIALOG
		LicenseDetailsDialog,
        LicenseDetailsComponent,
		LicenseTransferDetailsComponent,
		PCLimiterComponent,
		
        // WINDOW
        LicenseDetailsWindow,
        MemberDetailsWindow,
        EmailWindow,
        NoteWindow,
        TicketWindow,
        TicketAddWindow,
        IFrameDialog,

        CKEditorModule
    ],
    providers: [
        clientFilesFilter,
        registryFilter
    ]
})

export class SharedAppDialogModule {}
